import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import barChart from '@/components/bigDataChart/barChart';
import { getAction } from '@/api/manage';
export default {
  name: 'CarExpendModal',
  components: {
    barChart: barChart
  },
  data: function data() {
    return {
      title: '',
      tableName: '',
      visible: false,
      confirmLoading: false,
      userId: '',
      limitSelectDate: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      url: {
        queryAttendance: '/om/attendance/info/queryAttendance'
      }
    };
  },
  props: {},
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.sdate = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.edate = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  methods: {
    handleDetail: function handleDetail(userId) {
      this.userId = userId;
      this.visible = true;
      this.timeQuery();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    onServicenDateChange: function onServicenDateChange(value, dateString) {
      this.sdate = dateString[0];
      this.edate = dateString[1];
    },
    timeQuery: function timeQuery() {
      var that = this;
      var params = {
        atdnDateStart: this.sdate,
        atdnDateEnd: this.edate,
        userId: this.userId
      };
      getAction(this.url.queryAttendance, params).then(function (res) {
        if (res.success) {
          var data = {
            legendData: [],
            seriesData: []
          };
          res.result.forEach(function (v, i) {
            data.legendData.push(v.siteName);
            data.seriesData.push({
              value: v.number,
              name: v.siteName
            });
          });
          that.drawChart('chart1', data, '站点打卡次数');
        }
      });
    },
    drawChart: function drawChart(chartId, data, seriesName) {
      var option = {
        title: {
          text: '各站点打卡次数',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          width: '100%',
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          top: 20,
          bottom: 10,
          data: data.legendData
        },
        series: [{
          name: seriesName,
          type: 'pie',
          radius: '50%',
          center: ['50%', '60%'],
          // label: {
          //   normal: {
          //     show: true,
          //     formatter: '{c}({d}%)'
          //   }
          // },
          data: data.seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      var chart1 = this.$refs.chart1;
      var myChart = this.$echarts.init(chart1);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};